import Component from './campaign_add_widget_dialog.vue'
export default Component
